import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=9f820f9c&scoped=true&"
import script from "./OtpVerification.vue?vue&type=script&lang=ts&"
export * from "./OtpVerification.vue?vue&type=script&lang=ts&"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=9f820f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f820f9c",
  null
  
)

export default component.exports